<template>
  <div
    class="creative-state d-flex align-items-center justify-content-center"
    :class="[isActiveCreativeTemplate ? 'is-active' : 'is-paused']"
  >
    <p
      class="mb-0 p-3"
    >
      Creative State: <span>{{ `${isActiveCreativeTemplate ? 'ACTIVE' : 'INACTIVE'}` }}</span>
    </p>
    <i
      class="p-3 d-flex justify-content-center align-items-center icon far"
      :class="[isActiveCreativeTemplate ? 'fa-play' : 'fa-pause']"
      @click="toggleCreativeContentState"
    />
  </div>
</template>
<script>
import {
  mapActions, mapGetters, mapState,
} from 'vuex';
import * as contentTypes from '@/modules/content/store/types';
import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'PlayPauseButton',
  computed: {
    ...mapState('campaigns', [
      'selectedAdvertiser',
    ]),
    ...mapState('content', [
      'selectedArticleUuid',
      'selectedCreativeId',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_MANAGED_CAMPAIGN,
      campaignTypes.GET_IS_CAMPAIGN_LIVE,
    ]),
    ...mapGetters('content', [
      contentTypes.GET_CONTENT_ITEM_ACTIVE_STATE,
    ]),
    isActiveCreativeTemplate() {
      return this.GET_CONTENT_ITEM_ACTIVE_STATE(this.selectedArticleUuid, this.selectedCreativeId);
    },
  },
  methods: {
    ...mapActions('content', [
      contentTypes.UPDATE_A_CREATIVE_CONTENT_STATE,
    ]),
    toggleCreativeContentState() {
      if (!this.GET_IS_MANAGED_CAMPAIGN && !this.GET_IS_CAMPAIGN_LIVE) return;
      const payload = {
        advertiserId: this.selectedAdvertiser.id,
        creativeId: this.selectedCreativeId,
        updatedItem: {
          contentItemUuid: this.selectedArticleUuid,
          active: !this.isActiveCreativeTemplate,
        },
      };
      this.UPDATE_A_CREATIVE_CONTENT_STATE(payload)
        .then(() => {
          this.$emit('updateState');
        });
    },
  },
};
</script>
<style scoped lang="scss">
.creative-state {
  color: $body-color;
  box-sizing: border-box;
  height: 29px;
  border-radius: 4px;
  font-size: $font-size-sm;
  &.is-active {
    background-color: $success;
    border: 1px solid $success-light;
    color: $white;
    .icon {
      color: inherit;
      &:active, &:hover, &:focus {
        background-color: $success-dark;
        color: inherit;
      }
    }
  }
  &.is-paused {
    background-color: $danger;
    border: 1px solid $danger-light;
    color: $white;
    .icon {
      color: inherit;
      &:active, &:hover, &:focus {
        background-color: $danger-dark;
        color: inherit;
      }
    }
  }
  .icon {
    cursor: pointer;
    font-size: inherit;
    width: 35px;
    height: 100%;
  }
  .far, .fa-play, .fa-pause {
    color: $body-color;
    &:hover {
      color: $white;
  }
  }
  p {
    margin-bottom: unset;
  }
}
</style>
